import { render } from "./SavedJobs.vue?vue&type=template&id=145c01b6"
import script from "./SavedJobs.vue?vue&type=script&lang=js"
export * from "./SavedJobs.vue?vue&type=script&lang=js"

import "./SavedJobs.vue?vue&type=style&index=0&id=145c01b6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__